'use strict';

import React from 'react';

const STATE_SET = 'State.set';
const COUNTRY_SET = 'Country.set';
const CENTER_SET = 'Center.set';

export default class AutocompleteItem extends React.Component {
  handleClick = () => {
    this.props.handleItemClick(this.props.place.main_text);
    this.emitPlaceDetails();
  }

  emitPlaceDetails() {
    const { state, country, center } = this.props.place;

    if (state) {
      this.props.updater.emit(
        STATE_SET,
        { long_name: state.long_name, short_name: state.short_name }
      );
    }

    if (country) {
      this.props.updater.emit(
        COUNTRY_SET,
        { long_name: country.long_name, short_name: country.short_name }
      );
    }

    if (center) {
      this.props.updater.emit(
        CENTER_SET,
        { lat: center.lat, lng: center.lng }
      );
    }
  }

  render() {
    return (
      (<li ref="li" onClick={this.handleClick}>
        {this.props.place.description}
      </li>)
    );
  }
}
